<div id="loader-wrapper">
  <div id="loader"></div>
  <div class="loading-logo">Omni Soluções Financeiras</div>

  <div class="loader-section section-left"></div>
  <div class="loader-section section-right"></div>

</div>
